<script>
import { backUrl } from '@src/config.js'
import axios from 'axios'
import moment from 'moment-timezone'
import { useIndexStore } from '@src/store'

export default {
  name: 'LeftPanelControls',
  props: {
    currentProject: {
      type: Object,
      default: () => null,
    },
    isRecordable: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: [
    'openPlanningDialog',
  ],
  data () {
    return {
      recordingData: null,
    }
  },
  computed: {
    store () {
      return useIndexStore()
    },
    projectStatus () {
      return this.currentProject ? this.currentProject.project_state.description : null
    },
    isProjectAvailable () {
      return this.projectStatus === 'available'
    },
    isProjectRecording () {
      return this.projectStatus === 'recording'
    },
    projectId () {
      return this.currentProject.id
    },
    projectName () {
      return this.currentProject.name
    },
  },
  methods: {
    openPlanningDialog () {
      this.$emit('openPlanningDialog')
    },
    async populateProjectByID (idProject) {
      const response = await axios.get(`${backUrl}projects/${idProject}`)
      if (response.data.id) {
        this.store.changeProject(response.data)
      }
    },
    async startRecording () {
      try {
        await axios.get(`${backUrl}projects/${this.projectId}/start_recording`)
        await this.populateProjectByID(this.projectId) // reload the store ==> MapPage has up-to-date project status
      } catch (error) {
        this.store.changeNotification({
          text: error.response ? error.response.data.error : error,
          autoClose: true,
          type: 'error',
        })
      }
    },
    async stopRecording () {
      try {
        await axios.get(`${backUrl}projects/${this.projectId}/stop_recording`)
        this.store.changeNotification({
          text: this.$gettext('Recording has been cancelled'),
          autoClose: true,
          type: 'info',
        })
        await this.populateProjectByID(this.projectId)
      } catch (error) {
        this.store.changeNotification({
          text: error.response ? error.response.data.error : error,
          autoClose: true,
          type: 'error',
        })
      }
    },
    getHtmlLink(data, name) {
      const link = document.createElement('a')
      link.download = name
      const csvBlobData = new Blob([data], { type: 'text/csv' })
      const csvUrl = URL.createObjectURL(csvBlobData)
      link.href = csvUrl
      return link
    },
    clickOnHtmlLink(link) {
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportCSV () {
      try {
        const response = await axios.get(`${backUrl}actions/projects/${this.projectId}/csv_duration/invoke`)
        const date = moment().format('DD-MM-YY')
        const link = this.getHtmlLink(response.data, `${this.projectName}-${date}.csv`)
        this.clickOnHtmlLink(link)
      } catch (error) {
        this.store.changeNotification({
          text: error.response ? error.response.data.error : error,
          autoClose: true,
          type: 'error',
        })
      }
    },
  },
}
</script>
<template>
  <div class="left-panel-controls">
    <v-list density="compact">
      <v-list-item
        base-color="secondary"
        prepend-icon="fa-solid fa-gears fa-fw"
        :disabled="!isProjectAvailable"
        :title="$gettext('Schedule recording')"
        @click="openPlanningDialog"
      />
      <v-list-item
        v-if="!isProjectRecording"
        base-color="secondary"
        prepend-icon="fa-solid fa-bolt fa-fw"
        :disabled="!isRecordable"
        :title="$gettext('Start recording')"
        @click="startRecording"
      />
      <v-list-item
        v-else
        base-color="secondary"
        prepend-icon="fa-solid fa-clock-rotate-left fa-fw"
        :title="$gettext('Stop recording')"
        @click="stopRecording"
      />
      <v-list-item
        base-color="secondary"
        prepend-icon="fa-solid fa-download fa-fw"
        :title="$gettext('Export CSV')"
        @click="exportCSV"
      />
    </v-list>
  </div>
</template>
<style lang="scss" scoped>
.left-panel-controls {
  display: flex;
  flex-direction: column;
  gap: 1ch;
}
</style>
